import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFrBE from '@angular/common/locales/fr-BE';
import localeNlBE from '@angular/common/locales/nl-BE';

registerLocaleData(localeFrBE, 'fr-BE');
registerLocaleData(localeNlBE, 'nl-BE');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
